/* Medina · hero slideshow · vanilla, sin dependencias (~1,5 KB min) */
(function(){
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');
  function init(root){
    if (root.__mbh) return; root.__mbh = 1;
    var slides = [].slice.call(root.querySelectorAll('.mbh__slide')); if (slides.length < 2) return;
    var dots = [].slice.call(root.querySelectorAll('.mbh__dot'));
    var pauseBtn = root.querySelector('.mbh__pause');
    var ms = +root.dataset.autoplay || 0, cur = 0, timer = null;
    var hover = false, focus = false, user = false, visible = true;
    if (RM && RM.matches) { ms = 0; }
    if (!ms && pauseBtn) pauseBtn.hidden = true;
    function preload(i){ var s = slides[i]; if (!s) return; [].forEach.call(s.querySelectorAll('img[loading="lazy"]'), function(im){ im.loading = 'eager'; }); }
    function go(i, fromUser){
      i = (i + slides.length) % slides.length; if (i === cur) return;
      var old = slides[cur], nw = slides[i];
      slides.forEach(function(s){ s.classList.remove('is-prev'); });
      old.classList.remove('is-active'); old.classList.add('is-prev'); old.setAttribute('aria-hidden','true'); old.inert = true;
      nw.classList.add('is-active'); nw.removeAttribute('aria-hidden'); nw.inert = false;
      dots.forEach(function(d, k){ if (k === i) d.setAttribute('aria-current','true'); else d.removeAttribute('aria-current'); });
      cur = i; preload(i + 1);
      root.dispatchEvent(new CustomEvent('mbh:show', { detail: nw }));
      if (fromUser) root.querySelector('.mbh__track').setAttribute('aria-live','polite');
      schedule();
    }
    function running(){ return ms && !hover && !focus && !user && visible && !document.hidden; }
    function schedule(){ clearTimeout(timer); if (running()) timer = setTimeout(function(){ go(cur + 1); }, ms); }
    root.querySelector('.mbh__prev').addEventListener('click', function(){ go(cur - 1, true); });
    root.querySelector('.mbh__next').addEventListener('click', function(){ go(cur + 1, true); });
    dots.forEach(function(d){ d.addEventListener('click', function(){ go(+d.dataset.go, true); }); });
    if (pauseBtn) pauseBtn.addEventListener('click', function(){
      user = !user; pauseBtn.setAttribute('aria-pressed', user ? 'true' : 'false');
      pauseBtn.setAttribute('aria-label', user ? 'Reanudar el pase automático' : 'Pausar el pase automático'); schedule();
    });
    root.addEventListener('keydown', function(e){
      if (e.target.closest('input,textarea')) return;
      if (e.key === 'ArrowRight') { go(cur + 1, true); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(cur - 1, true); e.preventDefault(); }
    });
    root.addEventListener('mouseenter', function(){ hover = true; schedule(); });
    root.addEventListener('mouseleave', function(){ hover = false; schedule(); });
    root.addEventListener('focusin', function(){ focus = true; schedule(); });
    root.addEventListener('focusout', function(e){ if (!root.contains(e.relatedTarget)) { focus = false; schedule(); } });
    var x0 = null;
    root.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function(e){ if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 45) go(cur + (dx < 0 ? 1 : -1), true); }, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ visible = es[0].isIntersecting; schedule(); }, { threshold: .25 }).observe(root);
    if (RM && RM.addEventListener) RM.addEventListener('change', function(){ if (RM.matches) { ms = 0; clearTimeout(timer); } });
    /* precarga la 2.ª slide cuando la página ya ha cargado (no compite con el LCP) */
    if (document.readyState === 'complete') setTimeout(function(){ preload(1); }, 1500);
    else window.addEventListener('load', function(){ setTimeout(function(){ preload(1); }, 1500); });
    schedule();
  }
  function all(){ [].forEach.call(document.querySelectorAll('[data-mbh]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:block:select', function(e){
    var s = e.target.closest && e.target.closest('.mbh__slide'); if (!s) return;
    var r = s.closest('[data-mbh]'); var btn = r && r.querySelector('.mbh__dot[data-go="'+s.dataset.idx+'"]'); if (btn) btn.click();
  });
})();
